import { render } from "./Maib.vue?vue&type=template&id=5cf1e85f&scoped=true"
import script from "./Maib.vue?vue&type=script&lang=js"
export * from "./Maib.vue?vue&type=script&lang=js"

import "./Maib.vue?vue&type=style&index=0&id=5cf1e85f&lang=scss&scoped=true"

import exportComponent from "D:\\svn_gongzuo\\_____base\\GoPay\\v3_gopay\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf1e85f"]])

export default __exports__